import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import { ResourceType } from '../types/resource';
export function getBiDataForBadge(badge) {
    return BiData({
        evid: 100,
        itemid: badge.typeId,
        typeid: ResourceType.BADGE,
        page_typeid: BiContextProvidedValue,
        page_itemid: BiContextProvidedValue,
        sectionid: BiContextProvidedValue,
        sectionrank: BiContextProvidedValue,
        sectionname: BiContextProvidedValue,
        sectiontype: BiContextProvidedValue,
        section_typeid: BiContextProvidedValue,
        widgetname: BiContextProvidedValue
    });
}
